import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import LunkadLogo from "../../assets/lu.png";
import { useLocation, useNavigate } from "react-router-dom";
import config from "../../config";
import { buttonClick } from "utils/googleAnalytics";

const drawerWidth = 240;
const navItems = [
  { path: "/", title: "Home" },
  { path: "/our-story", title: "Our Story" },
  // {
  //   title: "Sign in",
  //   onClick: () => {
  //     buttonClick({ buttonName: "Sign In" });
  //     window.open(config.signInUrl, "_blank");
  //   },
  // },
];

export default function Header(props) {
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const location = useLocation();
  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };
  const navigate = useNavigate();

  const handleRedirect = (item) => {
    if (item?.onClick) {
      item.onClick();
    } else if (item?.path) {
      navigate(item.path);
    }
  };

  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: "center" }}>
      <Box
        onClick={() => {
          navigate("/");
        }}
        sx={{ py: 3.5, cursor: "pointer" }}
      >
        <img
          src={LunkadLogo}
          alt="lusoft-logo"
          style={{ borderRadius: "10px", height: "30px" }}
        />
      </Box>
      <Divider />
      <List>
        {navItems.map((item) => (
          <ListItem
            key={item.title}
            disablePadding
            onClick={() => handleRedirect(item)}
          >
            <ListItemButton sx={{ textAlign: "center" }}>
              <ListItemText
                disableTypography
                primary={
                  <Typography
                    variant="body2"
                    sx={{
                      color: (theme) =>
                        location?.pathname === item.path
                          ? theme.palette.common.darkGrey
                          : theme.palette.common.lightGrey,
                    }}
                  >
                    {item.title}
                  </Typography>
                }
              />
            </ListItemButton>
          </ListItem>
        ))}

        {/* <Button
          variant="contained"
          size="large"
          target="_blank"
          href={config.signUpUrl}
          onClick={() => {
            buttonClick({ buttonName: "Sign Up" });
          }}
          sx={{
            backgroundColor: (theme) => theme.palette.common.darkGrey,
            "&:hover": {
              backgroundColor: (theme) => theme.palette.common.darkGrey,
            },
            fontSize: "18px",
            lineHeight: "27px",
            fontWeight: 700,
          }}
        >
          Sign up for Free
        </Button> */}
      </List>
    </Box>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar
        component="nav"
        sx={{
          backgroundColor: (theme) => theme.palette.common.white,
          py: 2.25,
          px: { xs: 2, md: 10, lg: 23 },
        }}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: "none" } }}
          >
            <MenuIcon />
            <img
              src={LunkadLogo}
              alt="Lunkad-logo"
              // height="100%"
              style={{
                borderRadius: "10px",
                height: "30px",
                marginLeft: "15px",
              }}
            />
          </IconButton>
          <Box
            sx={{
              flexGrow: 1,
              display: "block",
              height: { xs: "36px", md: "60px" },
              display: { xs: "none", sm: "block" },
              cursor: "pointer",
            }}
            onClick={() => {
              navigate("/");
            }}
          >
            <img
              src={LunkadLogo}
              alt="Lunkad-logo"
              // height="100%"
              style={{ borderRadius: "10px", height: "45px" }}
            />
          </Box>
          <Box sx={{ display: { xs: "none", sm: "block" } }}>
            {navItems.map((item) => (
              <Button
                key={item.title}
                onClick={() => handleRedirect(item)}
                sx={{
                  color: (theme) =>
                    location?.pathname === item.path
                      ? theme.palette.common.darkGrey
                      : theme.palette.common.lightGrey,
                  fontSize: { xs: 16, md: 18 },
                  fontWeight: 700,
                  lineHeight: "22.73px",
                  marginRight: { xs: 1, md: 2 },
                }}
              >
                {item.title}
              </Button>
            ))}
            {/* <Button
              variant="contained"
              target="_blank"
              href={config.signUpUrl}
              sx={{
                backgroundColor: (theme) => theme.palette.common.darkGrey,
                "&:hover": {
                  backgroundColor: (theme) => theme.palette.common.darkGrey,
                },
                fontSize: { xs: "16px", md: "18px" },
                lineHeight: "27px",
                fontWeight: 700,
                py: { xs: "8px", md: "12px" },
                px: { xs: "10px", md: "20px" },
              }}
            >
              Sign up for Free
            </Button> */}
          </Box>
        </Toolbar>
      </AppBar>
      <nav>
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
        >
          {drawer}
        </Drawer>
      </nav>
    </Box>
  );
}
